import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { ReturnRequestDto } from "@babackapp/private-api-client/types";

const formSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phone: z.string().optional(),
  address1: z.string().optional(),
  address2: z.string().optional(),
  country: z.object({
    name: z.string().optional(),
    code: z.string().optional(),
  }),
  zip: z.string().optional(),
  province_code: z.string().optional(),
  city: z.string().optional(),
});

export default function useEditShippingAddressForm(
  returnRequest: ReturnRequestDto,
) {
  const { shipping_address: shippingAddress } = returnRequest;

  return useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      firstName: shippingAddress.first_name ?? "",
      lastName: shippingAddress.last_name ?? "",
      address1: shippingAddress.address1 ?? "",
      address2: shippingAddress.address2 ?? "",
      zip: shippingAddress.zip ?? "",
      city: shippingAddress.city ?? "",
      country: {
        name: shippingAddress.country ?? "France",
        code: shippingAddress.country_code ?? "Fr",
      },
      province_code: shippingAddress.province_code ?? "",
      phone: shippingAddress.phone ?? "",
    },
  });
}
